import { render, staticRenderFns } from "./SithMesTpmSpindleDataTsdListNew.vue?vue&type=template&id=40739580&"
import script from "./SithMesTpmSpindleDataTsdListNew.vue?vue&type=script&lang=js&"
export * from "./SithMesTpmSpindleDataTsdListNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports